import React, { useState, useEffect } from "react";
import {
    Button,
    ButtonGroup,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Row,
    Col,
} from "reactstrap";
import { toast } from "react-toastify";
import { apiURL } from '../../config';


import axios from "axios";

const CustomTable = ({ columns, data }) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    {columns.map((column, index) => (
                        <th key={index}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data && data.length > 0 ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td key={colIndex}>
                                    {column.toLowerCase() === "actions"
                                        ? row.actions
                                        : row[column.toLowerCase().replace(/ /g, "")]}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length}>No data available</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

const Courses = () => {
    const token = localStorage.getItem("token");

    const [searchQuery, setSearchQuery] = useState("");
    const [courses, setCourses] = useState([]);
    const [courseToDelete, setCourseToDelete] = useState(null);
    const [courseDeleteModalOpen, setCourseDeleteModalOpen] = useState(false);
    const [courseToView, setCourseToView] = useState(null);
    const [courseViewModalOpen, setCourseViewModalOpen] = useState(false);
    const [courseToEdit, setCourseToEdit] = useState(null);
    const [courseEditModalOpen, setCourseEditModalOpen] = useState(false);
    const [editCourseName, setEditCourseName] = useState("");
    const [editCourseCode, setEditCourseCode] = useState("");
    const [numberOfSubjects, setNumberOfSubjects] = useState(0);
    const [editNumberOfSubjects, setEditNumberOfSubjects] = useState(0);
    const [subjectDropdowns, setSubjectDropdowns] = useState([]);
    const [showSubjectModal, setShowSubjectModal] = useState(false);
    const [allSubjects, setAllSubjects] = useState([]);
    const [allTeachers, setAllTeachers] = useState([]);
    const [courseName, setCourseName] = useState("");
    const [courseCode, setCourseCode] = useState("");
    const [courseModalOpen, setCourseModalOpen] = useState(false);
    const [editSubjectDropdowns, setEditSubjectDropdowns] = useState([]);

    useEffect(() => {
        fetchCourses();
        fetchSubjects();
        fetchTeachers();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await axios.get(
                `${apiURL}/superadmin/courses`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }
            );
            setCourses(response.data);
        } catch (error) {
            toast.error("Error fetching courses. Refresh the page");

            console.error("Error fetching courses:", error);
        }
    };

    const fetchSubjects = async () => {
        try {
            const response = await axios.get(
                `${apiURL}/superadmin/subjects`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }
            );
            setAllSubjects(response.data);
        } catch (error) {
            console.error("Error fetching subjects:", error);
        }
    };

    const fetchTeachers = async () => {
        try {
            const response = await axios.get(
                `${apiURL}/superadmin/getTeachersName`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }
            );
            setAllTeachers(response.data.teachers);
        } catch (error) {
            console.error("Error fetching teachers:", error);
        }
    };

    const handleViewCourse = (course) => {
        setCourseToView(course);
        setCourseViewModalOpen(true);
    };

    const toggleCourseViewModal = () => {
        setCourseToView(null);
        setCourseViewModalOpen(!courseViewModalOpen);
    };

    const handleEditCourse = (course) => {
        setCourseToEdit(course);
        setEditCourseName(course.courseName);
        setEditCourseCode(course.courseCode);
        setEditNumberOfSubjects(course.subjects.length);
        setEditSubjectDropdowns(course.subjects.map(sub => ({
            subject: sub.subject?._id || '-',
            teacher: sub.teacher?._id || '-',
            passingMarks: sub?.passingMarks || '-'
        })));
        setCourseEditModalOpen(true);
    };

    const toggleCourseEditModal = () => {
        setCourseToEdit(null);
        setCourseEditModalOpen(!courseEditModalOpen);
    };

    const handleUpdateCourse = async (e) => {
        e.preventDefault();
        try {
            const subjectsData = editSubjectDropdowns.map((item) => ({
                subject: item?.subject || '-',
                teacher: item?.teacher || '-',
                passingMarks: item?.passingMarks || '-',
            }));
            await axios.put(
                `${apiURL}/superadmin/courses/${courseToEdit._id}`,
                {
                    courseName: editCourseName,
                    courseCode: editCourseCode,
                    subjects: subjectsData
                }, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }
            );
            fetchCourses();
            toggleCourseEditModal();
            setShowSubjectModal(false);
            toast.success("Course updated successfully!");

        } catch (error) {
            if (error.status === 409) {
                toast.error("Two same subjects cannot be add in one course");
                return;
            }
            toast.error("Error updating course. Try again Later");

            console.error("Error updating course:", error);
        }
    };

    const handleDeleteCourse = (course) => {
        setCourseToDelete(course);
        setCourseDeleteModalOpen(true);
    };

    const confirmDeleteCourse = async () => {
        try {
            await axios.delete(
                `${apiURL}/superadmin/courses/${courseToDelete._id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }
            );
            fetchCourses();
            setCourseDeleteModalOpen(false);
            toast.success("Course Deleted successfully!");

        } catch (error) {
            if (error.status === 409) {
                toast.error("Course is exits in class. First remove it from the class.");
                return;
            }
            toast.error("Error deleting course. Try again Later");

            console.error("Error deleting course:", error);
        }
    };

    const toggleCourseDeleteModal = () => {
        setCourseToDelete(null);
        setCourseDeleteModalOpen(!courseDeleteModalOpen);
    };

    const handleAddSubjects = () => {
        if (numberOfSubjects > 0) {
            setSubjectDropdowns(
                Array(parseInt(numberOfSubjects)).fill({
                    subject: "",
                    teacher: "",
                    passingMarks: "",
                })
            );
            setShowSubjectModal(true);
        }
    };

    const handleSubjectSelection = (index, field, value) => {
        const newSubjectDropdowns = [...subjectDropdowns];
        newSubjectDropdowns[index] = { ...newSubjectDropdowns[index], [field]: value };
        setSubjectDropdowns(newSubjectDropdowns);
    };

    const handleEditSubjectSelection = (index, field, value) => {
        const newSubjectDropdowns = [...editSubjectDropdowns];
        newSubjectDropdowns[index] = { ...newSubjectDropdowns[index], [field]: value };
        setEditSubjectDropdowns(newSubjectDropdowns);
    };

    const handleSubmitCourse = async () => {
        try {
            const subjectsData = subjectDropdowns.map((item) => ({
                subject: item?.subject || '-',
                teacher: item?.teacher || '-',
                passingMarks: item?.passingMarks || '-',
            }));
            await axios.post(`${apiURL}/superadmin/courses`, {
                courseName: courseName,
                courseCode: courseCode,
                subjects: subjectsData,
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            });
            fetchCourses();
            setShowSubjectModal(false);
            toggleCourseModal();
            toast.success("Course Added Successfully!");
            setCourseCode(""); setCourseCode(""); setNumberOfSubjects(0)

        } catch (error) {
            if (error.status === 409) {
                toast.error("Two same subjects cannot be add in one course");
                return;

            }
            toast.error("Error adding new course. Try again Later");

            console.error("Error adding course:", error);
        }
    };

    const toggleCourseModal = () => {
        setCourseModalOpen(!courseModalOpen);
    };

    const handleAddCourse = (e) => {
        e.preventDefault();
        setCourseModalOpen(true);
    };

    const handleEditNumberOfSubjects = (e) => {
        setEditNumberOfSubjects(e.target.value);
    };

    const handleUpdateSubjectRows = () => {
        setEditSubjectDropdowns(prev => {
            const newDropdowns = [...prev];
            const diff = editNumberOfSubjects - prev.length;
            if (diff > 0) {
                for (let i = 0; i < diff; i++) {
                    newDropdowns.push({ subject: "", teacher: "", passingMarks: "" });
                }
            } else if (diff < 0) {
                newDropdowns.splice(diff);
            }
            return newDropdowns;
        });
    };

    const handleRemoveSubject = (index) => {
        setEditSubjectDropdowns(prev => {
            const newDropdowns = [...prev];
            newDropdowns.splice(index, 1);
            setEditNumberOfSubjects(newDropdowns.length)
            return newDropdowns;
        });
    };

    const filteredCourses = courses ? courses.filter(
        (course) =>
            course.courseName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            course.courseCode.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    const columns = [
        "Course Name",
        "Course Code",
        "Number of Subjects",
        "Actions",
    ];

    return (
        <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Courses Management</h3>
                <Input
                    type="text"
                    placeholder="Search by Course Name or Code"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ maxWidth: "300px" }}
                />
                <Button color="primary" size="sm" onClick={toggleCourseModal}>
                    Add Course
                </Button>
            </CardHeader>
            <CardBody>
                <CustomTable
                    columns={columns}
                    data={filteredCourses ? filteredCourses.map((course) => ({
                        coursename: course.courseName,
                        coursecode: course.courseCode,
                        numberofsubjects: course.subjects.length,
                        actions: (
                            <ButtonGroup size="sm">
                                <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleDeleteCourse(course)}
                                >
                                    Delete
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => handleEditCourse(course)}
                                >
                                    Edit
                                </Button>
                                <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => handleViewCourse(course)}
                                >
                                    View
                                </Button>
                            </ButtonGroup>
                        ),
                    })) : []}
                />
            </CardBody>

            {/* View Course Modal */}
            <Modal isOpen={courseViewModalOpen} toggle={toggleCourseViewModal} size="lg">
                <ModalHeader toggle={toggleCourseViewModal}>
                    Course Details
                </ModalHeader>
                <ModalBody>
                    {courseToView && (
                        <div>
                            <p>
                                <strong>Course Name:</strong> {courseToView.courseName}
                            </p>
                            <p>
                                <strong>Course Code:</strong> {courseToView.courseCode}
                            </p>
                            <p>
                                <strong>Subjects:</strong>
                            </p>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Subject Name</th>
                                        <th>Staff</th>
                                        <th>Passing Marks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {courseToView.subjects.map((sub, index) => (
                                        <tr key={index}>
                                            <td>{sub.subject?.name || '-'}</td>
                                            <td>{sub.teacher?.name || '-'}</td>
                                            <td>{sub.passingMarks}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleCourseViewModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Edit Course Modal */}
            <Modal isOpen={courseEditModalOpen} toggle={toggleCourseEditModal} size="lg">
                <form onSubmit={handleUpdateCourse}>
                    <ModalHeader toggle={toggleCourseEditModal}>
                        Edit Course
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="editCourseName">Course Name</Label>
                            <Input
                                type="text"
                                id="editCourseName"
                                placeholder="Enter Course Name"
                                value={editCourseName}
                                onChange={(e) => setEditCourseName(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="editCourseCode">Course Code</Label>
                            <Input
                                type="text"
                                id="editCourseCode"
                                placeholder="Enter Course Code"
                                value={editCourseCode}
                                onChange={(e) => setEditCourseCode(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup className="d-flex align-items-center">
                            <Label for="editNumberOfSubjects" className="mr-2">Number of Subjects</Label>
                            <Input
                                type="number"
                                id="editNumberOfSubjects"
                                placeholder="Number of Subjects"
                                value={editNumberOfSubjects}
                                onChange={handleEditNumberOfSubjects}
                                required
                                className="mr-2"
                            />
                            <Button color="primary" type="button" onClick={handleUpdateSubjectRows}>
                                Add
                            </Button>
                        </FormGroup>
                        {editSubjectDropdowns.map((subjectData, index) => (
                            <Row key={index} className="mb-3">
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for={`subject-${index}`}>Subject Name</Label>
                                        <Input
                                            type="select"
                                            id={`subject-${index}`}
                                            value={subjectData.subject}
                                            onChange={(e) =>
                                                handleEditSubjectSelection(
                                                    index,
                                                    "subject",
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            <option value="">Select a subject</option>
                                            {allSubjects.map((subject) => (
                                                <option key={subject._id} value={subject._id}>
                                                    {subject.name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for={`teacher-${index}`}>Teacher Name</Label>
                                        <Input
                                            type="select"
                                            id={`teacher-${index}`}
                                            value={subjectData.teacher}
                                            onChange={(e) =>
                                                handleEditSubjectSelection(
                                                    index,
                                                    "teacher",
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            <option value="">Select a staff</option>
                                            {allTeachers.map((teacher) => (
                                                <option key={teacher?._id || '-'} value={teacher?._id || '-'}>
                                                    {teacher?.name || '-'}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for={`passingMarks-${index}`}>Passing Marks</Label>
                                        <Input
                                            type="number"
                                            id={`passingMarks-${index}`}
                                            value={subjectData.passingMarks}
                                            onChange={(e) =>
                                                handleEditSubjectSelection(
                                                    index,
                                                    "passingMarks",
                                                    e.target.value
                                                )
                                            }
                                            required
                                            min="0"
                                            max="100"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={1} className="d-flex align-items-center">
                                    <Button
                                        color="danger"
                                        size="sm"
                                        onClick={() => handleRemoveSubject(index)}
                                    >
                                        Delete
                                    </Button>
                                </Col>
                            </Row>
                        ))}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type="submit">
                            Save Changes
                        </Button>
                        <Button color="secondary" onClick={toggleCourseEditModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>

            {/* Delete Course Modal */}
            <Modal
                isOpen={courseDeleteModalOpen}
                toggle={toggleCourseDeleteModal}
            >
                <ModalHeader toggle={toggleCourseDeleteModal}>
                    Delete Course
                </ModalHeader>
                <ModalBody>
                    {courseToDelete ? (
                        <p>
                            Are you sure you want to delete the course:{" "}
                            {courseToDelete.courseName}?
                        </p>
                    ) : (
                        <p>No course selected.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteCourse}>
                        Delete
                    </Button>
                    <Button color="secondary" onClick={toggleCourseDeleteModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Add Course Modal */}
            <Modal isOpen={courseModalOpen} toggle={toggleCourseModal}>
                <form onSubmit={handleSubmitCourse}>
                    <ModalHeader toggle={toggleCourseModal}>Add Course</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="courseName">Course Name</Label>
                            <Input
                                type="text"
                                id="courseName"
                                placeholder="Enter Course Name"
                                value={courseName}
                                onChange={(e) => setCourseName(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="courseCode">Course Code</Label>
                            <Input
                                type="text"
                                id="courseCode"
                                placeholder="Enter Course Code"
                                value={courseCode}
                                onChange={(e) => setCourseCode(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="numberOfSubjects">Number of Subjects</Label>
                            <div className="d-flex">
                                <Input
                                    type="number"
                                    id="numberOfSubjects"
                                    placeholder="Number of Subjects"
                                    value={numberOfSubjects}
                                    onChange={(e) => setNumberOfSubjects(e.target.value)}
                                    required
                                    className="mr-2"
                                />
                                <Button color="primary" onClick={handleAddSubjects}>
                                    Add
                                </Button>
                            </div>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="primary" type="submit">
                            Next
                        </Button> */}
                        <Button color="secondary" onClick={toggleCourseModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </form>
            </Modal>

            {/* Modal for Adding Subjects to Course */}
            <Modal
                isOpen={showSubjectModal}
                toggle={() => setShowSubjectModal(false)}
                size="lg"
            >
                <ModalHeader toggle={() => setShowSubjectModal(false)}>
                    Add Subjects to Course
                </ModalHeader>
                <ModalBody>
                    {subjectDropdowns.map((subjectData, index) => (
                        <Row key={index} className="mb-3">
                            <Col md={4}>
                                <FormGroup>
                                    <Label for={`subject-${index}`}>Subject {index + 1}</Label>
                                    <Input
                                        type="select"
                                        id={`subject-${index}`}
                                        value={subjectData.subject}
                                        onChange={(e) =>
                                            handleSubjectSelection(
                                                index,
                                                "subject",
                                                e.target.value
                                            )
                                        }
                                        required
                                    >
                                        <option value="">Select a subject</option>
                                        {allSubjects.map((subject) => (
                                            <option key={subject._id} value={subject._id}>
                                                {subject.name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for={`teacher-${index}`}>Teacher Name</Label>
                                    <Input
                                        type="select"
                                        id={`teacher-${index}`}
                                        value={subjectData?.teacher || '-'}
                                        onChange={(e) =>
                                            handleSubjectSelection(
                                                index,
                                                "teacher",
                                                e.target.value
                                            )
                                        }
                                        required
                                    >
                                        <option value="">Select a staff</option>
                                        {allTeachers.map((teacher) => (
                                            <option key={teacher?._id || '-'} value={teacher?._id || '-'}>
                                                {teacher?.name || '-'}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for={`passingMarks-${index}`}>Passing Marks</Label>
                                    <Input
                                        type="number"
                                        id={`passingMarks-${index}`}
                                        value={subjectData.passingMarks}
                                        onChange={(e) =>
                                            handleSubjectSelection(
                                                index,
                                                "passingMarks",
                                                e.target.value
                                            )
                                        }
                                        required
                                        min="0"
                                        max="100"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    ))}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={handleSubmitCourse}
                        disabled={subjectDropdowns.some(
                            (subject) =>
                                !subject?.subject || !subject?.teacher || !subject.passingMarks
                        )}
                    >
                        Add Course
                    </Button>
                    <Button color="secondary" onClick={() => setShowSubjectModal(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Card>
    );
};

export default Courses;
